import axios from "@/shared/scripts/AutoRefreshAxios";
import { AxiosError } from "axios";
import { BackOfficeAction } from "../interfaces/BackOfficeAction.interface";
import { Classified } from "../interfaces/classified/Classified.interface";
import store from "../store";

const baseUrl: string = process.env.VUE_APP_CLASSIFIEDS_MANAGEMENT_URL || "";
const version = "1";

export async function extendClassified(backOfficeAction: BackOfficeAction): Promise<string[]|boolean> {

    const classified: Classified = store.getters["MyClassifiedsModule/getClassifiedToExtend"];
    if (!classified) {
        return Promise.resolve(false);
    }
    const uri = `/backoffice/classifieds/${classified.id}/extend`;
    //method and endpoint change if classifiedId already exists
    const method = "post";

    return axios({
        method: method,
        url: baseUrl + version + uri,
        data: backOfficeAction,
        headers: {
            "Authorization": "Bearer " + store.getters["UserModule/getUser"].jwtAdmin,
            "customerId": classified.customerId
        }
    })
        .then(() => Promise.resolve(true))
        .catch((e: AxiosError) => Promise.reject(e.response?.data.errors));
}

export async function reactivateClassified(backOfficeAction: BackOfficeAction): Promise<any> {
    const classified: Classified = store.getters["MyClassifiedsModule/getClassifiedToReactivate"];
    if (!classified) {
        return Promise.resolve(false);
    }
    const uri = `/backoffice/classifieds/${classified.id}/reactivate`;

    return axios({
        method: "post",
        url: baseUrl + version + uri,
        data: backOfficeAction,
        headers: {
            "Authorization": "Bearer " + store.getters["UserModule/getUser"].jwtAdmin,
            "customerId": classified.customerId
        }
    })
        .then(res => res.data)
        .catch(error => {
            throw new Error(error);
        });
}

export async function activateClassified(backOfficeAction: BackOfficeAction): Promise<any> {
    const classified: Classified = store.state.MyClassifiedsModule.classifiedToActivate;
    if (!classified) {
        return Promise.resolve(false);
    }
    const uri = `/backoffice/classifieds/${classified.id}/activate`;

    return axios({
        method: "post",
        url: baseUrl + version + uri,
        data: backOfficeAction,
        headers: {
            "Authorization": "Bearer " + store.getters["UserModule/getUser"].jwtAdmin,
        }
    })
        .then(res => res.data)
        .catch(error => {
            throw new Error(error);
        });
}

export async function upgradeClassified(backOfficeAction: BackOfficeAction): Promise<any> {
    const classified: Classified = store.state.MyClassifiedsModule.classifiedToUpgrade;
    if (!classified) {
        return false;
    }
    const uri = `/backoffice/classifieds/${classified.id}/upgrade`;

    return axios({
        method: "post",
        url: baseUrl + version + uri,
        data: backOfficeAction,
        headers: {
            "Authorization": "Bearer " + store.getters["UserModule/getUser"].jwtAdmin,
            "customerId": classified.customerId
        }
    })
        .then(res => res.data)
        .catch(error => {
            throw new Error(error);
        });
}
